// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 177 ? "home" : chunkId) + "-legacy." + {"95":"a133c2ab","157":"6aa1c43f","177":"82a32115","189":"eeb4008d","392":"c32ab548","548":"77e5a3ce"}[chunkId] + ".js";
};